import React from 'react';

function ServiceHeader({ title, subtitle, imageUrl }) {
  return (
    <section className='grid w-full border-b-4 border-solid border-colour6'>
      <div
        className={`grid relative w-full ${imageUrl} min-h-[50vh] lg:min-h-[80vh] bg-cover bg-center bg-no-repeat`}
      >
        {/* Transparent Black Overlay */}
        <div className='absolute inset-0 bg-black/10'></div>

        {/* Content */}
        <div className='absolute text-center top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  font-StencilW01 '>
          <div className='text-5xl lg:text-7xl text__stroke'>
            <span>{title}</span>
          </div>
          <div className='text-colour6 px-4 text-xl'>
            <span>{subtitle}</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ServiceHeader;
